export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const USER_ACTIVATION_SUCCESS = 'USER_ACTIVATION_SUCCESS';
export const USER_ACTIVATION_FAIL = 'USER_ACTIVATION_FAIL';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const RESET_PASSWORD_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const RESET_PASSWORD_FAIL = 'PASSWORD_RESET_FAIL';

export const SET_AUTH_MESSAGE = 'SET_AUTH_MESSAGE';
export const CLEAR_AUTH_MESSAGE = 'CLEAR_AUTH_MESSAGE';

export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';

export const START_DRAW = 'START_DRAW';
export const STOP_DRAW = 'STOP_DRAW';
export const CLEAN_DRAW = 'CLEAN_DRAW';
export const MODIFY_DRAW = 'MODIFY_DRAW';
export const CLEAN_MODIFY_DRAW = 'CLEAN_MODIFY_DRAW';

export const UPLOAD_VEKTOR = 'UPLOAD_VEKTOR';
export const DOWNLOAD_VECTOR = 'DOWNLOAD_VECTOR';

export const START_MEASURE = 'START_MEASURE';
export const STOP_MEASURE = 'STOP_MEASURE';
export const CLEAN_MEASURE = 'CLEAN_MEASURE';

export const ADD_LAYER_CONTROL = 'ADD_LAYER_CONTROL';
export const ADD_SWIPE_CONTROL = 'ADD_SWIPE_CONTROL';
export const REMOVE_SWIPE_CONTROL = 'REMOVE_SWIPE_CONTROL';
export const ADD_POPUP_OVERLAY_CONTROL = 'ADD_POPUP_OVERLAY_CONTROL';
export const REMOVE_POPUP_OVERLAY_CONTROL = 'REMOVE_POPUP_OVERLAY_CONTROL';
export const ADD_COLOR_FILTER = 'ADD_COLOR_FILTER';
export const REMOVE_COLOR_FILTER = 'REMOVE_COLOR_FILTER';
export const UPDATE_COLOR_FILTER = 'UPDATE_COLOR_FILTER';

export const ADD_FEATURE_LAYER_TO_MAP = 'ADD_FEATURE_LAYER_TO_MAP';
export const REMOVE_FEATURE_LAYER_FROM_MAP = 'REMOVE_FEATURE_LAYER_FROM_MAP';
export const ADD_LAYER_TO_MAP = 'ADD_LAYER_TO_MAP';
export const REMOVE_LAYER_FROM_MAP = 'REMOVE_LAYER_FROM_MAP';
export const ADD_BASE_LAYER_TO_MAP = 'ADD_BASE_LAYER_TO_MAP';
export const REMOVE_BASE_LAYER_FROM_MAP = 'REMOVE_BASE_LAYER_FROM_MAP';
export const ACTIVE_BASE_LAYER = 'ACTIVE_BASE_LAYER';

export const CHANGE_PROJECTION = 'CHANGE_PROJECTION';

export const ADD_SYNCHRONIZE_INTERACTION = 'ADD_SYNCHRONIZE_INTERACTION';
export const REMOVE_SYNCHRONIZE_INTERACTION = 'REMOVE_SYNCHRONIZE_INTERACTION';

export const ADD_GLOBAL_MAP = 'ADD_GLOBAL_MAP';
export const REMOVE_GLOBAL_MAP = 'REMOVE_GLOBAL_MAP';

export const ADD_INFO_FEATURE = 'ADD_INFO_FEATURE';
export const REMOVE_INFO_FEATURE = 'REMOVE_INFO_FEATURE';

export const PASSIVE_INFO_MODE = 'PASSIVE_INFO_MODE';
export const GET_INFO_VECTOR = 'GET_INFO_VECTOR';
export const GET_INFO_WMS = 'GET_INFO_WMS';

export const ACTIVE_INFO_PANEL = 'ACTIVE_INFO_PANEL';
export const PASSIVE_INFO_PANEL = 'PASSIVE_INFO_PANEL';

export const CREATE_DATA_TO_ATTRIBUTE = 'CREATE_DATA_TO_ATTRIBUTE';
export const READ_DATA_TO_ATTRIBUTE = 'READ_DATA_TO_ATTRIBUTE';
export const UPDATE_DATA_TO_ATTRIBUTE = 'UPDATE_DATA_TO_ATTRIBUTE';
export const DELETE_DATA_TO_ATTRIBUTE = 'DELETE_DATA_TO_ATTRIBUTE';
export const SHOW_HIDE_DATA_ATTRIBUTE_TABLE = 'SHOW_HIDE_DATA_ATTRIBUTE_TABLE';
export const SET_ATTRIBUTE_TABLE_ID = 'SET_ATTRIBUTE_TABLE_ID';
